import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { Card, CardContent, CardHeader, Box, Tooltip, Typography, ListItem, IconButton, DialogActions, ListItemSecondaryAction, Chip } from '@mui/material';
import Alert from 'src/components/Alert';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import 'src/assets/css/confirmOverlay.css';
const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    }),
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    confirmOverlay: {
        zIndex: 9999 + ' !important'
    }
};



function Overview(props) {
    const { basvuruId, documentType, dosyaAdet, documentTypeNumber, openClose, uploadingFile, setUploadingFile, setFilesDataToSend } = props;
    const [uyari, setUyari] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [searchName, setSearchName] = React.useState('')
    const [uploadFilePopUp, setUploadFilePopUp] = React.useState(false);
    const [uyariTip, setUyariTip] = React.useState(false);
    const [fileType, setFileType] = React.useState(0);
    const [fileTypeDesc, setFileTypeDesc] = React.useState(0);
    const [uyariAciklama, setUyariAciklama] = React.useState('')
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const [isDragActive, setIsDragActive] = React.useState(false);
    const fileInputRef = React.useRef(null);
    const MAX_FILE_SIZE = 8072000;
    const ACCEPTED_FILE_TYPE = 'application/pdf';





    const setNewWindowOpen = (row) => {
        setLoading(true);
        var FileData = `data:${row.FileType};base64,${row.FileData}`
        if (row?.FileType?.includes('image')) {
            var image = new Image();
            image.src = FileData;
            var w = window.open("");
            w.document.write(image.outerHTML);
            w.document.title = row.FileName;
            w.document.close();
        } else {
            var blobData = base64ToBlob(row.FileData, "application/pdf");
            openBlobInNewTab(blobData);
        }
        setLoading(false);
    }


    function base64ToBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    function openBlobInNewTab(blobData) {
        var newTab = window.open();
        var objectUrl = URL.createObjectURL(blobData);
        newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
    }


    const handleDeleteSureClick = (id) => {
        confirmAlert({
            message: ('Silmek istediğinizden emin misiniz?'),
            buttons: [
                {
                    label: ('Evet'),
                    onClick: () => handleDeleteClick(id)
                },
                {
                    label: ('Hayır'),
                    onClick: () => { }
                }
            ],
            overlayClassName: "confirmOverlay"
        });
    }

    const handleDeleteClick = (fileId) => {
        const data = uploadingFile.filter((item) => item.id != fileId)
        setUploadingFile(data && data.length > 0 ? data : []);
        setUyari(true);
        setUyariAciklama("İşleminiz başarı ile gerçekleşti.")
        setUyariTip("success")
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };
    const addSelectedFiles = (fileList) => {
        const incoming = Array.from(fileList || []);
        let hasInvalidType = false;
        let hasInvalidSize = false;
        const validFiles = [];
        incoming.forEach((file) => {
            if (file.type !== ACCEPTED_FILE_TYPE) {
                hasInvalidType = true;
                return;
            }
            if (file.size > MAX_FILE_SIZE) {
                hasInvalidSize = true;
                return;
            }
            validFiles.push(file);
        });
        if (hasInvalidType) {
            setUyariAciklama("Sadece pdf dosya yükleyebilirsiniz. Lütfen dosya tipini kontrol ediniz!...");
            setUyari(true);
            setUyariTip("error");
        } else if (hasInvalidSize) {
            setUyariAciklama("Dosya boyutu çok büyük. Lütfen dosya boyutunu kontrol ediniz!...");
            setUyari(true);
            setUyariTip("error");
        }
        if (validFiles.length > 0) {
            setSelectedFiles((prev) => [...prev, ...validFiles]);
        }
    };

    const handleDropFiles = (event) => {
        event.preventDefault();
        setIsDragActive(false);
        addSelectedFiles(event.dataTransfer.files);
    };

    const handleRemoveSelectedFile = (index) => {
        setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    };

    const handleUploadClick = () => {
        if (selectedFiles.length === 0) {
            return;
        }
        const files = selectedFiles.map((file) => ({ file, meta: { name: file.name, type: file.type } }));
        const allFiles = selectedFiles.map(() => ({ remove: () => {} }));
        handleSubmitImage(files, allFiles);
        setSelectedFiles([]);
    };

    const handleSubmitImage = async (files, allFiles) => {
        setFilesDataToSend(files);
        var fileIsRequired = documentType.filter(i => i.ID == fileType)[0].ZORUNLU || false;
        if (files.length < props.dosyaAdet && fileIsRequired == 1) {
            setUyariAciklama("Yüklenen dosya adedi, seçilen kişi sayısından büyük ya da eşit olmadılıır. Lütfen kontrol ediniz!...")
            setUyari(true);
            setUyariTip("error");
            return;
        }
        setLoading(true)
        var tempArray = uploadingFile;
        var Ids = uploadingFile.map(item => item.id);
        var maxId = Ids.length > 0 ? Math.max(...Ids) : 0;
        for (let i = 0; i < files.length; i++) {
            var fileMaterial = files[i].file;
            var metaMaterial = files[i].meta;
            let base64ResultMaterial = '';
            if (metaMaterial.type.indexOf('image') !== -1) {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const image = new Image();
                image.src = URL.createObjectURL(fileMaterial);
                await new Promise((resolve, reject) => {
                  image.onload = () => {
                    const maxWidth = 1920;
                    const maxHeight = 1920;
                    let width = image.width;
                    let height = image.height;
                    if (width > maxWidth || height > maxHeight) {
                      if (width / height > maxWidth / maxHeight) {
                        width = maxWidth;
                        height = Math.round(maxWidth * (image.height / image.width));
                      } else {
                        height = maxHeight;
                        width = Math.round(maxHeight * (image.width / image.height));
                      }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(image, 0, 0, width, height);
                    base64ResultMaterial = canvas.toDataURL(metaMaterial.type, 1).split(',')[1];
                    resolve();
                  };
                  image.onerror = reject;
                });
              } else {
                base64ResultMaterial = await base64Reader(fileMaterial);
            }

            var data = {
                id: ++maxId,
                FileName: metaMaterial.name,
                FileType: metaMaterial.type,
                ReceiptNumber: basvuruId,
                FileData: base64ResultMaterial,
                TypeId: fileType,
                FileNameWithType: fileTypeDesc + ' - ' + metaMaterial.name,
                OnOnay: 1,
                OpenClose: openClose,
                FileUploadData:files[i]
            }
            tempArray = [...tempArray, data]
            setLoading(false)
            setUploadFilePopUp(false)
            setUyariTip("success");
        }
        setUploadingFile(tempArray);
        allFiles.forEach(f => f.remove())
    };





    async function base64Reader(file) {
        const result_base64 = await new Promise(resolve => {
            const fileReader = new FileReader();
            fileReader.onload = e => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });
        return result_base64.split(',')[1] || '';
    }

    return (
        <>
            <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={uyariKapat} variant={uyariTip} message={uyariAciklama}>
                </Alert>
            </Snackbar>
            <Card>
                <CardHeader title="Belge Yükle" />
                <CardContent>
                    <TextField
                        id="standard-basic"
                        label="Ara"
                        value={searchName}
                        onChange={(event) => setSearchName(event.target.value)}
                        fullWidth
                        size="small"
                        sx={{ mb: 2 }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        {documentType.length > 0 && documentType
                            ?.filter(i => i.ACIKLAMA?.toLowerCase().includes(searchName.toLowerCase()))
                            ?.map((row, index) => {
                                const filesForType = uploadingFile.filter((f) => f.TypeId === row.ID);
                                const isRequired = row.ZORUNLU === 1;
                                const isSatisfied = filesForType.length > 0;
                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 2,
                                            p: 1.5
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            {isSatisfied ? (
                                                <CheckCircleIcon color="success" />
                                            ) : isRequired ? (
                                                <ErrorOutlineIcon color="error" />
                                            ) : (
                                                <RadioButtonUncheckedIcon color="disabled" />
                                            )}
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={{ fontWeight: 600 }}>
                                                    {row.ACIKLAMA} <span style={{ color: 'red' }}> (*pdf)</span>
                                                </Typography>
                                                <Box sx={{ display: 'flex', gap: 0.75, mt: 0.5, flexWrap: 'wrap' }}>
                                                    <Chip
                                                        size="small"
                                                        label={isRequired ? 'Zorunlu' : 'Opsiyonel'}
                                                        color={isRequired ? 'error' : 'default'}
                                                        variant="outlined"
                                                    />
                                                    <Chip
                                                        size="small"
                                                        label={filesForType.length > 0 ? `${filesForType.length} dosya yüklendi` : 'Eksik'}
                                                        color={filesForType.length > 0 ? 'success' : (isRequired ? 'error' : 'default')}
                                                    />
                                                </Box>
                                            </Box>
                                            <Tooltip title="Dosya Yükle">
                                                <IconButton
                                                    edge="end"
                                                    onClick={() => {
                                                        setUploadFilePopUp(true)
                                                        setFileType(row.ID)
                                                        setFileTypeDesc(row.ACIKLAMA);
                                                        setSelectedFiles([]);
                                                    }}>
                                                    <AttachFileOutlinedIcon color="primary" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        {filesForType.length > 0 && (
                                            <List dense sx={{ mt: 1 }}>
                                                {filesForType.map((file) => (
                                                    <ListItem key={file.id} disablepadding>
                                                        <ListItemText primary={file.FileName} />
                                                        <ListItemSecondaryAction>
                                                            <Tooltip title="Göster">
                                                                <IconButton size="small" onClick={() => setNewWindowOpen(file)}>
                                                                    <VisibilityIcon color='primary' fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Sil">
                                                                <IconButton size="small" onClick={() => handleDeleteSureClick(file.id)}>
                                                                    <DeleteIcon color='primary' fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        )}
                                    </Box>
                                );
                            })}
                    </Box>
                </CardContent>
            </Card>
            <Dialog
                open={uploadFilePopUp}
                onClose={() => { setUploadFilePopUp(false); setSelectedFiles([]); }}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ width: '100%' }} >Dosya Yükle</DialogTitle>
                <DialogContent sx={{ pt: 2.5 }}>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="application/pdf"
                        multiple
                        hidden
                        onChange={(event) => {
                            addSelectedFiles(event.target.files);
                            event.target.value = '';
                        }}
                    />
                    <Box
                        onClick={() => fileInputRef.current?.click()}
                        onDragOver={(event) => { event.preventDefault(); setIsDragActive(true); }}
                        onDragLeave={() => setIsDragActive(false)}
                        onDrop={handleDropFiles}
                        sx={{
                            minHeight: 200,
                            maxHeight: 250,
                            border: '2px dashed',
                            borderColor: isDragActive ? '#FF9800' : '#bdbdbd',
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            backgroundColor: isDragActive ? 'rgba(255,152,0,0.05)' : 'transparent',
                            transition: 'all 0.2s ease',
                            p: 2
                        }}
                    >
                        <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                            {selectedFiles.length > 0
                                ? `${dosyaAdet - selectedFiles.length} ekle`
                                : 'Dosyayı sürükleyip bırakın ya da tıklayın'}
                        </Typography>
                    </Box>

                    {selectedFiles.length > 0 && (
                        <List dense sx={{ mt: 1 }}>
                            {selectedFiles.map((file, index) => (
                                <ListItem key={index} disablepadding>
                                    <ListItemText primary={file.name} />
                                    <ListItemSecondaryAction>
                                        <IconButton size="small" onClick={() => handleRemoveSelectedFile(index)}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))}
                        </List>
                    )}

                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={selectedFiles.length === 0}
                        onClick={handleUploadClick}
                    >
                        Yükle
                    </Button>
                </DialogContent>
                <DialogActions>
                    <DialogActions>
                        <IconButton
                            color="primary"
                            onClick={() => { setUploadFilePopUp(false); setSelectedFiles([]); }}
                            aria-label="close"
                            component="span"
                            variant="contained"
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Overview;
